import { NavLink, Link } from 'react-router-dom';
import {
  Drawer as MuiDrawer, BottomNavigationAction, IconButton, Fab,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { GlobeIcon } from '@client/images/feather/GlobeIcon';
import { ShowsIcon } from '@client/images/feather/ShowsIcon';
import { useSelector } from '@client/hooks/redux.hooks';
import { hasDisabledNavigationSelector } from '@client/selectors/helpers/router';
import { SideDoorIcon } from '@client/images/logos/SideDoorIcon';
import { Spacer } from '@client/components/common/Spacer';
import { Drawer } from '../Drawer';
import { UserPlusIcon } from '../common/UserPlusIcon';
import { openSignupModal } from '../../Signup';
import { hasBorderSelector } from '../common/selectors';

const drawerWidth = 86;

const useStyles = makeStyles()((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,

    '& > .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(1.5, 0),
      alignItems: 'center',
      position: 'sticky',
      top: 0,
      height: '100vh',
      borderColor: 'transparent',
    },
  },
  logo: {
    color: theme.palette.grey[600],
    marginBottom: theme.spacing(1),
  },
  border: {
    '& > .MuiDrawer-paper': {
      borderColor: theme.palette.divider,
    },
  },
  fab: {
    marginTop: theme.spacing(1),
  },
  action: {
    flex: 0,
    height: theme.spacing(7),
    borderWidth: 0,
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),

    '& > .MuiBottomNavigationAction-label': {
      opacity: 1,
    },
  },
  disabled: {
    pointerEvents: 'none',
  },
}));

export const LoggedOutDesktopNav = () => {
  const { classes, cx } = useStyles();

  const hasBorder = useSelector(hasBorderSelector);
  const hasDisabledNavigation = !!(useSelector(hasDisabledNavigationSelector));

  return (
    <MuiDrawer
      variant="permanent"
      className={cx(classes.drawer, hasBorder && classes.border)}
    >
      <IconButton
        size="xlarge"
        component={Link}
        to="/home"
        aria-label="Go to front page"
        title="Home"
        id="sda-nav-logo-button"
        className={classes.logo}
      >
        <SideDoorIcon />
      </IconButton>

      <Fab
        color="secondary"
        variant="square"
        className={classes.fab}
        aria-label="Sign Up"
        onClick={() => openSignupModal()}
      >
        <UserPlusIcon />

        Sign Up
      </Fab>

      <Spacer margin="xsmall" />

      <BottomNavigationAction
        label="Connect"
        component={NavLink}
        to="/connect"
        icon={<GlobeIcon />}
        className={cx(classes.action, hasDisabledNavigation && classes.disabled)}
      />

      <BottomNavigationAction
        label="Upcoming Shows"
        component={NavLink}
        to="/shows"
        icon={<ShowsIcon />}
        className={cx(classes.action, hasDisabledNavigation && classes.disabled)}
      />

      <div className="spacer" />

      <Drawer />
    </MuiDrawer>
  );
};

export default LoggedOutDesktopNav;
